import styled from 'styled-components'

export const Body = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
  width: '47rem',
}))

export const Toggles = styled.div({
  display: 'flex',
  flexDirection: 'column',
})
